import { State } from './state';
import { ContainerController } from './container';
import { StorageController } from './storage';
import { EventController } from './events';
export class Simple {
    constructor(incomingStruct, c) {
        // internal data store object
        this._data = Object.create({});
        this.bindToGlobal();
        // initialize container controller that handles the re renders for useSimple hook
        this.containerController = new ContainerController(this);
        this.storage = new StorageController(this, c === null || c === void 0 ? void 0 : c.storage);
        this.events = new EventController(this);
        // save the default structure as a flat map
        this.defaultStructure = Object.assign(incomingStruct, {});
        // build the base structure
        for (let item of Object.entries(incomingStruct)) {
            const key = item[0];
            const val = item[1];
            this._data[key] = new State(this, key, val);
            this._data[key].set(val);
        }
    }
    // Easy and a clean way to access the core object without any other function that comes with the instance
    core() {
        return Object.assign(Object.assign({}, this._data), { _events: this.events.eventsRegistryList });
    }
    reset() {
        for (const i of Object.entries(this._data)) {
            this._data[i[0]].reset();
        }
    }
    // Register the keys that will be persisted
    persist(keys) {
        this.storage.persistence_keys = keys;
        // this will sync up the core with storage and reversed in order
        this.storage.initializeStorageWithCore();
    }
    // Bind the instance to the global window
    bindToGlobal() {
        if (!globalThis['Simple_']) {
            globalThis['Simple_'] = this;
        }
    }
}
//# sourceMappingURL=simple.js.map